import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dialog, DialogContent, DialogTitle, Grid, makeStyles } from '@material-ui/core';
import moment from 'moment';

import { Challenge } from './Challenge';
import { updateChallenge, deleteChallenge } from '../api';
import { actions } from '../_redux';
import { ChallengeForm } from './ChallengeForm';
import { useConfirmation } from '../../../providers/Confirmation';

export const ChallengeList = ({ challenges }) => {
	const [editingChallenge, setEditingChallenge] = React.useState(null);
	const [backdropUpdate, setBackdropUpdate] = useState(false)
	const classes = useStyles();
	const dispatch = useDispatch();
	const confirm = useConfirmation();

	const handleChallengeUpdate = challenge => {
		if (challenge) {
			challenge._id = editingChallenge._id;
			updateChallenge(challenge).then(() => {
				challenge.from = moment(challenge.from).format('MM/DD/YYYY');
				challenge.to = moment(challenge.to).format('MM/DD/YYYY');
				dispatch(actions.updateChallenge(challenge));
			});
		}
		setEditingChallenge(null);
	};

	const handleChallengeDelete = async challenge => {
		try {
			await confirm({
				title: 'Are you sure to delete the challenge?',
				description: "This won't be reverted.",
			});
			await deleteChallenge(challenge);
			dispatch(actions.deleteChallenge(challenge));
		} catch (err) { }
	};

	const handleChallengeBackdropClick = async () => {
		try {
			await confirm({
				title: 'Do you want to save current settings?',
				description: ' ',
			});
			setBackdropUpdate(true)
		} catch (err) { }
	};

	return (
		<>
			<Grid container spacing={2} style={{ marginTop: 24 }}>
				{challenges && challenges.length ? challenges.map(challenge => (
					<Grid item key={challenge._id}>
						<Challenge
							challenge={challenge}
							participations={challenge.count}
							deleteChallenge={() => handleChallengeDelete(challenge)}
							editChallenge={() => setEditingChallenge(challenge)}
						/>
					</Grid>)) : null}
			</Grid>
			<Dialog
				disableBackdropClick
				onBackdropClick={() => handleChallengeBackdropClick()}
				classes={{
					paperWidthSm: classes.dialog,
				}}
				open={!!editingChallenge}
				onClose={() => setEditingChallenge(null)}
				style={{ borderRadius: 10, maxWidth: 'unset' }}
			>
				<DialogTitle>Update a challenge</DialogTitle>
				<DialogContent className={classes.content}>
					{editingChallenge && (
						<ChallengeForm challenge={editingChallenge} onClose={handleChallengeUpdate} onBackdropUpdate={backdropUpdate} />
					)}
				</DialogContent>
			</Dialog>
		</>
	);
};

const useStyles = makeStyles(() => ({
	dialog: {
		maxWidth: 'unset',
		borderRadius: 10,
	},
	content: {
		marginBottom: 12,
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#F5F5F5',
		},
		'&::-webkit-scrollbar': {
			width: '4px',
			backgroundColor: '#F5F5F5',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#ccc',
		},
	},
}));
